// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=fa8df1b3-17c9-407f-90ff-d08b12bf0099";
};